/**
 * Date-extensions locale Central Atlas Tamazight [tzm]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('tzm', {
    monthNames: ['ⵉⵏⵏⴰⵢⵔ','ⴱⵕⴰⵢⵕ','ⵎⴰⵕⵚ','ⵉⴱⵔⵉⵔ','ⵎⴰⵢⵢⵓ','ⵢⵓⵏⵢⵓ','ⵢⵓⵍⵢⵓⵣ','ⵖⵓⵛⵜ','ⵛⵓⵜⴰⵏⴱⵉⵔ','ⴽⵟⵓⴱⵕ','ⵏⵓⵡⴰⵏⴱⵉⵔ','ⴷⵓⵊⵏⴱⵉⵔ'],
    monthShortNames: ['ⵉⵏⵏⴰⵢⵔ','ⴱⵕⴰⵢⵕ','ⵎⴰⵕⵚ','ⵉⴱⵔⵉⵔ','ⵎⴰⵢⵢⵓ','ⵢⵓⵏⵢⵓ','ⵢⵓⵍⵢⵓⵣ','ⵖⵓⵛⵜ','ⵛⵓⵜⴰⵏⴱⵉⵔ','ⴽⵟⵓⴱⵕ','ⵏⵓⵡⴰⵏⴱⵉⵔ','ⴷⵓⵊⵏⴱⵉⵔ'],
    dayNames: ['ⴰⵙⴰⵎⴰⵙ','ⴰⵢⵏⴰⵙ','ⴰⵙⵉⵏⴰⵙ','ⴰⴽⵔⴰⵙ','ⴰⴽⵡⴰⵙ','ⴰⵙⵉⵎⵡⴰⵙ','ⴰⵙⵉⴹⵢⴰⵙ'],
    dayShortNames: ['ⴰⵙⴰⵎⴰⵙ','ⴰⵢⵏⴰⵙ','ⴰⵙⵉⵏⴰⵙ','ⴰⴽⵔⴰⵙ','ⴰⴽⵡⴰⵙ','ⴰⵙⵉⵎⵡⴰⵙ','ⴰⵙⵉⴹⵢⴰⵙ']
});
